import React from "react";
import ActivateAccountUser from "../../components/activateAccount/ActivateAccountUser";

const ActivateAccountUserPage = () => {
	return (
		<>
			<ActivateAccountUser />
		</>
	);
};

export default ActivateAccountUserPage;
